// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__EHBQM","copyright":"Image_copyright__FGQDH","source":"Image_source__2VfJW"};